import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";

const ColorPicker = ({ onColorChange, ...props }) => {
  const [color, setColor] = useState("#FFFFFF");

  const onColorChangeHandler = (color) => {
    setColor(color.hex);
    onColorChange(color.hex);
  };

  const onChange = (color) => {
    setColor(color.hex);
  };

  return (
    <React.Fragment>
      <SketchPicker
        color={color}
        onChange={onChange}
        onChangeComplete={onColorChangeHandler}
        disableAlpha
      />
    </React.Fragment>
  );
};

export default ColorPicker;
